import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingJpegToBmpConfig } from '@/data/landingConfig/landingJpegToBmpConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_JpegToBmp } from './schemaObject';

interface Props {}
const JpegToBmpConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_JpegToBmp} />
			<LandingTemplate
				data={landingJpegToBmpConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default JpegToBmpConverter;
